import {
  PENGELOLAAN_KINERJA_BASE_PATH,
  PENGELOLAAN_KINERJA_TK_PENILIK_PATH,
  PENGELOLAAN_KINERJA_PPK_PENILIK_PATH,
} from 'app/KinerjaShared/constants/path'

export const getBasePath = (isTimKinerja, isPejabatPenilaiKinerja) => {
  if (isTimKinerja) {
    return PENGELOLAAN_KINERJA_TK_PENILIK_PATH
  }

  if (isPejabatPenilaiKinerja) {
    return PENGELOLAAN_KINERJA_PPK_PENILIK_PATH
  }

  return PENGELOLAAN_KINERJA_BASE_PATH
}
